import { render, staticRenderFns } from "./NewImagesModal.vue?vue&type=template&id=60750151&"
import script from "./NewImagesModal.vue?vue&type=script&lang=js&"
export * from "./NewImagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports